<template>
    <div v-if='todayMenus && todayMenus.length > 0' class='vbWrap'>
        <agile
            class='vbSlider todyMenu'
            :autoPlay='todayMenus.length > 0'
            :mobileFirst='true'
            :dots='false'
            :unagile="todayMenus.length < 2"
            :navButtons="todayMenus.length > 1"
            >
            <TodayMenuItem
                v-for='(menu, index) in todayMenus'
                :key='menu.code'
                :menu='menu'
                :index='index'
                :totalNo='todayMenus.length'/>
            <template v-if="todayMenus.length > 1" slot='prevButton'>
                <img class='nav_button' src='@/assets/img/ic_main_back.png'/>
            </template>
            <template v-if="todayMenus.length > 1" slot='nextButton'>
                <img class='nav_button' src='@/assets/img/ic_main_next.png'/>
            </template>
        </agile>
    </div>
</template>
<script lang="js">
import Vue from 'vue'
import { VueAgile } from 'vue-agile'
import { TODAY_MENU_CONTAINER } from '@/utils/EndPoint'
import TodayMenuItem from '@/components/MainPage/TodayMenuItem'

export default Vue.extend({
  name: TODAY_MENU_CONTAINER,
  components: {
    agile: VueAgile,
    TodayMenuItem
  },
  computed: {
    todayMenus () { return this.$store.getters.todayMenu }
  }
})
</script>
